import { BlockType } from '../../Block/Block';
import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import {
    UspItem,
    UspItemResource,
    UspSectionInterface,
    UspSectionResource,
} from './UspSection';

const transformToUspItem = (resource: UspItemResource): UspItem => {
    const icon = resource.icon
        ? resource.icon.icon
        : undefined;

    return {
        id: resource.id,
        icon,
        text: resource.title,
        link: resource.link,
    };
};

export const transformToUspSection = (resource: UspSectionResource): UspSectionInterface => {
    const defaultBlock = transformToDefaultBlock(resource);
    const items = resource.uniqueSellingPoint.map(transformToUspItem);

    return {
        ...defaultBlock,
        type: BlockType.uspSection,
        items,
        backgroundColor: resource?.color,
    };
};
